import React from "react";
import { Box, Container, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import InvertableStack from "../wrappers/InvertableStack";
import CenterScreen from "../wrappers/CenterScreen";
import usePrimaryColor from "../../hooks/usePrimaryColor";

function Center({ children }) {
  return (
    <Box
      mt={3}
      height={"30vh"}
      display={"flex"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      {children}
    </Box>
  );
}

export default function FullScreenMessageCore({
  icon,
  title,
  subtitle,
  children,
  button,
  containerPadding,
  titleSize,
  subtitleSize,
  containerBgColor,
  containerBoxShadow,
  shouldCenter = true,
  centerRelative = false,
  secondButton,
  withoutWrapper = true,
  testId,
}) {
  const { t } = useTranslation();
  const color = usePrimaryColor();
  function Icon() {
    return (
      <InvertableStack
        bgcolor={containerBgColor ? containerBgColor : color}
        padding={containerPadding ? containerPadding : 5}
        width={{ xs: 300, md: "auto" }}
        borderRadius={10}
        alignItems={"center"}
        spacing={{ xs: 3, md: 10 }}
        data-testid={testId && testId}
      >
        <Stack
          bgcolor={"white"}
          padding={2}
          borderRadius={10}
          boxShadow={0}
          alignItems={"center"}
        >
          {icon}
        </Stack>
        <Stack spacing={2}>
          {title ? (
            <Typography
              color={"white"}
              variant={titleSize ? titleSize : "h5"}
              fontSize={{ xs: "1.2rem", sm: "1.2rem", md: "1.4rem" }}
              textAlign={"center"}
            >
              {t(title)}
            </Typography>
          ) : null}
          {subtitle ? (
            <Typography
              color={"white"}
              variant={subtitleSize ? subtitleSize : null}
              textAlign={"center"}
            >
              {t(subtitle)}
            </Typography>
          ) : null}
          <Stack spacing={2}>
            {button}
            {secondButton ? secondButton : null}
          </Stack>
          {children}
        </Stack>
      </InvertableStack>
    );
  }

  if (centerRelative) {
    return (
      <Container>
        <Center>
          <Icon />
        </Center>
      </Container>
    );
  }
  if (shouldCenter) {
    return (
      <Container>
        <CenterScreen minHeight="80vh">
          <Icon />
        </CenterScreen>
      </Container>
    );
  }

  if (withoutWrapper) {
    return <Icon />;
  }

  return (
    <Container>
      <Icon />
    </Container>
  );
}
